import { Inject, Injectable } from '@angular/core';
import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';

import { EnvironmentConfig } from '../config/environment.config';

@Injectable({ providedIn: 'root' })
export class MonitoringService {
  private appInsights?: ApplicationInsights;

  get isInitialise(): boolean {
    return !!this.appInsights;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  constructor(@Inject('environment') private environment: EnvironmentConfig) {}

  init(): void {
    if (this.appInsights) {
      return;
    }

    if (!this.environment.appInsights.instrumentationKey) {
      return;
    }

    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: this.environment.appInsights.instrumentationKey
      }
    });
    this.appInsights.loadAppInsights();
  }

  addTelemetryInitializer(initializer: (item: ITelemetryItem) => boolean | void): void {
    this.appInsights?.addTelemetryInitializer(initializer);
  }

  logPageView(name?: string, url?: string): void {
    this.appInsights?.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }): void {
    this.appInsights?.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }): void {
    this.appInsights?.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number): void {
    this.appInsights?.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }): void {
    this.appInsights?.trackTrace({ message: message }, properties);
  }
}
